<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <div class="right">
          <router-link to="/deposithistory"
            ><i class="fad fa-clipboard-list"></i>
            {{ $t("History") }}</router-link
          >
        </div>
        <span>{{ $t("Funds") }}</span>
        <div class="left">
          <router-link to="/transactions"
            ><i class="fad fa-clipboard-list"></i>
            {{ $t("Transactions") }}</router-link
          >
        </div>
      </div>
    </div>

    <div class="orange-bg"></div>

    <div class="container-center lg">
      <div class="panel panel-b-dark">
        <div class="panel-body">
          <div class="text-center m-t-xs">
            <div v-if="getCoins['BTC']">
              Equity Value(BTC)
              <h3 class="m-t-xs">
                {{ amount(total_usd / getCoins["BTC"].last_price) }} BTC
                <br />
                <small>≈ $ {{ usd(total_usd) }}</small>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="tophead text-center row">
        <div
          class="col-xs-6 not-active"
          v-on:click="hideSmall()"
          v-if="hide.smallasset"
        >
          <p class="pointer">
            <i class="fad fa-eye-slash"></i> {{ $t("SmallAssets") }}
          </p>
        </div>
        <div class="col-xs-6 active" v-on:click="hideSmall()" v-else>
          <p class="pointer">
            <i class="fad fa-eye"></i> {{ $t("AllAssets") }}
          </p>
        </div>
        <div
          class="col-xs-6 not-active"
          v-on:click="hideDelisted()"
          v-if="hide.status"
        >
          <p class="pointer">
            <i class="fad fa-eye-slash"></i> {{ $t("Delisted") }}
          </p>
        </div>
        <div class="col-xs-6 active" v-on:click="hideDelisted()" v-else>
          <p class="pointer"><i class="fad fa-eye"></i> {{ $t("Delisted") }}</p>
        </div>
      </div>

      <div class="listcoin">
        <div v-if="getBalance && getCurrency && getCoins">
          <div v-for="b in getBalance" v-bind:key="b.id">
            <router-link
              v-bind:to="'/balancedetail/' + b.coin"
              tag="div"
              class="coin pointer"
              v-if="
                (getCurrency[b.coin].status === 'LEGEND' ||
                  getCurrency[b.coin].status === 'LISTED' ||
                  hide.status) &&
                (b.balance > 0 || hide.smallasset)
              "
            >
              <h5>
                <img :src="require(`@/assets/tokens/${b.coin}.png`)" />
                <span class="m-l-xs font-bold"
                  >{{ b.coin }}
                  <small>{{ getCurrency[b.coin].name }}</small></span
                >
                <span class="pull-right text-right">
                  <span class="font-bold">{{ amount(b.balance) }}</span
                  ><br /><small class="text-muted" v-if="getCoins[b.coin]">
                    ≈ $
                    {{ usd(getCoins[b.coin].last_price * b.balance) }}</small
                  >
                </span>
              </h5>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import func from "@/widgets/func";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      total_usd: 0,
      hide: JSON.parse(localStorage.getItem("HideAsset")) || {
        status: true,
        smallasset: true,
      },
    };
  },
  computed: mapGetters(["getBalance", "getCurrency", "getCoins"]),
  methods: {
    ...mapActions(["fetchBalance", "fetchCoins"]),
    hideDelisted() {
      this.hide.status = !this.hide.status;
      localStorage.setItem("HideAsset", JSON.stringify(this.hide));
    },
    hideSmall() {
      this.hide.smallasset = !this.hide.smallasset;
      localStorage.setItem("HideAsset", JSON.stringify(this.hide));
    },
    amount(a) {
      return func.fixed8(a);
    },
    usd(a) {
      return func.fixed2(a);
    },
    caltotal() {
      var total = 0;
      for (let [coin, value] of Object.entries(this.getBalance)) {
        if (this.getCoins[coin]) {
          total = total + value.balance * this.getCoins[coin].last_price;
        }
      }
      this.total_usd = total;
    },
  },
  created() {
    this.fetchBalance();
    this.fetchCoins();
  },
  updated() {
    this.caltotal();
  },
};
</script>

<style scoped>
.title {
  background-color: #f6a821;
  color: #000;
}
.right a {
  color: #000;
}
.left a {
  color: #000;
}
.orange-bg {
  background-color: #f6a821;
  height: 500px;
  margin-top: -400px;
  margin-bottom: -100px;
}
.panel {
  border-radius: 10px;
}
.middle-line {
  vertical-align: middle;
  line-height: 32px;
}
.fas {
  margin-right: 5px;
}
.active p {
  color: #f6a821;
  border-bottom-color: #f6a821;
  border-bottom: solid;
}
.not-active p {
  padding-bottom: 3px;
}
.container-center {
  margin-top: 40px;
  padding: 10px 10px 72px 10px;
}
.coin {
  border-bottom: 0.5px solid #494b54;
  vertical-align: middle;
  padding: 1px;
}
</style>
